import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { ContentSearch } from '../models/content';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  getCategoryList(contentMasterId: string){
    return this.http.get<any>(this.commonService.apiUrl + '/content/' + contentMasterId + '/category', {})
  }
  getContentList(search: ContentSearch) {
    let param = JSON.parse(JSON.stringify(search))
    if(param.processStatus == '') param.processStatus = null
    if(param.contentAnswerYn == '') param.contentAnswerYn = null
    if(param.contentCategoryNo == 0) param.contentCategoryNo = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/content/list', param)
  }
  getContentInfo(contentNo: number){
    return this.http.get<any>(this.commonService.apiUrl + '/content/' + contentNo, {})
  }
  addContent(formData: FormData) {
    return this.http.post<any>(this.commonService.apiUrl + '/content', formData);
  }
  updateContent(contentNo: number, formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/content/' + contentNo, formData);
  }
  changeStatus(contentNo: number, isOpen: boolean) {
    const formData = new FormData();
    formData.append('metaData', new Blob([JSON.stringify({status: isOpen ? 'ON' : 'OF'})], { type: "application/json" }))
    return this.http.put<any>(this.commonService.apiUrl + '/content/' + contentNo, formData);
  }
  removeContent(contentNo: number) {
    return this.http.delete<any>(this.commonService.apiUrl + '/content/' + contentNo, {});
  }
  removeContentList(contentNoList: number[]) {
    return this.http.post<any>(this.commonService.apiUrl + '/content/remove', {
      contentNoList: contentNoList
    });
  }
  addContentAnswer(contentNo: number, answer: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/content/' + contentNo + '/answer', {
      answer: answer
    });
  }
  removeContentAnswer(contentNo: number, contentAnswerNo: number) {
    return this.http.delete<any>(this.commonService.apiUrl + '/content/' + contentNo + '/answer/' + contentAnswerNo);
  }
}
